"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getArrayCell = exports.getDropdownSimpleWithRadioBtns = exports.getAvatarColumn = exports.getSpaceColumn = exports.getActionsBtns = exports.getMultiTagsCell = exports.getTagsColumn = exports.getTagColumn = exports.getTypographyColumn = exports.getTypographyTextColumn = exports.getDateColumn = exports.getSimpleColumn = exports.getActionsDropDown = exports.getNullableColumn = exports.NO_DATA = void 0;
var react_1 = __importDefault(require("react"));
var moment_1 = __importDefault(require("moment"));
var antd_1 = require("antd");
var icons_1 = require("@ant-design/icons");
var DropdownSimple_1 = require("../DropdownSimple");
var Typography_1 = require("../Typography");
var TagsMultiple_1 = require("../TagsMultiple");
var transifex_1 = require("../../transifex");
var Text = antd_1.Typography.Text;
exports.NO_DATA = react_1.default.createElement(Typography_1.Typography, { type: "secondary" }, transifex_1.TX_NO_DATA);
var getNullableColumn = function (children, fallback, truthTestFn) {
    if (children === void 0) { children = function (val) { return val; }; }
    if (fallback === void 0) { fallback = exports.NO_DATA; }
    if (truthTestFn === void 0) { truthTestFn = function (val) { return (val === 0 ? true : !!val); }; }
    return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var val = args[0];
        return truthTestFn(val) ? children.apply(void 0, args) : fallback;
    };
};
exports.getNullableColumn = getNullableColumn;
var getActionsDropDown = function (args) {
    return function (_, data) {
        var actions = args.actions;
        return (react_1.default.createElement(antd_1.Space, { size: "middle" },
            react_1.default.createElement(antd_1.Dropdown, { trigger: ["hover"], placement: "bottomRight", overlay: react_1.default.createElement(antd_1.Menu, null, actions.map(function (_a) {
                    var title = _a[0], action = _a[1];
                    return (react_1.default.createElement(antd_1.Menu.Item, { key: "1", onClick: function () { return action(data); } }, title));
                })) },
                react_1.default.createElement(icons_1.MoreOutlined, { style: { cursor: "pointer" } }))));
    };
};
exports.getActionsDropDown = getActionsDropDown;
var getSimpleColumn = function () { return exports.getNullableColumn(function (value) { return value; }); };
exports.getSimpleColumn = getSimpleColumn;
var getDateColumn = function (format, nullValue) {
    if (format === void 0) { format = "MMMM DD, YYYY HH:mm"; }
    if (nullValue === void 0) { nullValue = undefined; }
    return exports.getNullableColumn(function (value) { return moment_1.default(value).format(format); }, nullValue);
};
exports.getDateColumn = getDateColumn;
/** @deprecated */
var getTypographyTextColumn = function (children, textProps) {
    if (children === void 0) { children = function (val) { return val; }; }
    return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return react_1.default.createElement(Text, __assign({}, (textProps || {})), children.apply(void 0, args));
    };
};
exports.getTypographyTextColumn = getTypographyTextColumn;
var getTypographyColumn = function (children, props) {
    if (children === void 0) { children = function (val) { return val; }; }
    return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return react_1.default.createElement(Typography_1.Typography, __assign({}, (props || {})), children.apply(void 0, args));
    };
};
exports.getTypographyColumn = getTypographyColumn;
var getTagColumn = function (colorMap, render) {
    return function (val) {
        return react_1.default.createElement(antd_1.Tag, { color: colorMap === null || colorMap === void 0 ? void 0 : colorMap[val] }, (render === null || render === void 0 ? void 0 : render(val)) || val);
    };
};
exports.getTagColumn = getTagColumn;
var getTagsColumn = function (colorMap, render) {
    var renderTag = exports.getTagColumn(colorMap, render);
    return function (vals) {
        var rest = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            rest[_i - 1] = arguments[_i];
        }
        return (react_1.default.createElement(antd_1.Row, { gutter: [0, 8] }, vals.map(function (val) { return (react_1.default.createElement(antd_1.Col, null, renderTag === null || renderTag === void 0 ? void 0 : renderTag.apply(void 0, __spreadArray([val], rest)))); })));
    };
};
exports.getTagsColumn = getTagsColumn;
var getMultiTagsCell = function (children) {
    return function (tags) {
        var rest2 = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            rest2[_i - 1] = arguments[_i];
        }
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(TagsMultiple_1.TagsMultiple, { tags: tags }), children === null || children === void 0 ? void 0 :
            children.apply(void 0, __spreadArray([tags], rest2))));
    };
};
exports.getMultiTagsCell = getMultiTagsCell;
var getActionsBtns = function (args) {
    return function (_, data) {
        var actions = args.actions, _a = args.btnProps, btnProps = _a === void 0 ? {} : _a, _b = args.spaceProps, spaceProps = _b === void 0 ? {} : _b;
        return (react_1.default.createElement(antd_1.Space, __assign({ size: "middle" }, spaceProps), react_1.default.Children.toArray(actions
            .filter(function (_a) {
            var _b = _a.cond, cond = _b === void 0 ? function () { return true; } : _b;
            return cond(data);
        })
            .map(function (_a) {
            var handler = _a.handler, btnProps2 = _a.btnProps;
            return (react_1.default.createElement(antd_1.Button, __assign({}, btnProps, btnProps2, { onClick: function () {
                    var _a, _b;
                    var args1 = [];
                    for (var _i = 0; _i < arguments.length; _i++) {
                        args1[_i] = arguments[_i];
                    }
                    handler(data);
                    (_a = btnProps === null || btnProps === void 0 ? void 0 : btnProps.onClick) === null || _a === void 0 ? void 0 : _a.call.apply(_a, __spreadArray([btnProps], args1));
                    (_b = btnProps2 === null || btnProps2 === void 0 ? void 0 : btnProps2.onClick) === null || _b === void 0 ? void 0 : _b.call.apply(_b, __spreadArray([btnProps2], args1));
                } })));
        }))));
    };
};
exports.getActionsBtns = getActionsBtns;
var getSpaceColumn = function (children, spaceProps) {
    if (children === void 0) { children = function (val) { return val; }; }
    return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return react_1.default.createElement(antd_1.Space, __assign({}, spaceProps), children.apply(void 0, args));
    };
};
exports.getSpaceColumn = getSpaceColumn;
var getAvatarColumn = function (children, baseAvatarProps) {
    return function (_a) {
        var rest2 = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            rest2[_i - 1] = arguments[_i];
        }
        var avatarProps = _a.avatarProps, rest = __rest(_a, ["avatarProps"]);
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(antd_1.Avatar, __assign({}, baseAvatarProps, avatarProps)), children === null || children === void 0 ? void 0 :
            children.apply(void 0, __spreadArray([rest], rest2))));
    };
};
exports.getAvatarColumn = getAvatarColumn;
var getDropdownSimpleWithRadioBtns = function (args) {
    var getOpts = args.getOpts, dropdownSimpleProps = args.dropdownSimpleProps, children = args.children, defaultToggler = args.defaultToggler, radioProps = args.radioProps, onSelect = args.onSelect;
    return function () {
        var innerArgs = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            innerArgs[_i] = arguments[_i];
        }
        return (react_1.default.createElement(DropdownSimple_1.DropdownSimple, __assign({}, dropdownSimpleProps, { items: getOpts.apply(void 0, innerArgs).map(function (_a) {
                var label = _a.label, value = _a.value, checked = _a.checked;
                return ({
                    children: (react_1.default.createElement(antd_1.Radio, __assign({}, radioProps, { value: value, checked: checked, key: value, onClick: function (e) {
                            e.stopPropagation();
                        } }), label)),
                    onClick: function () {
                        onSelect === null || onSelect === void 0 ? void 0 : onSelect({ columnArgs: innerArgs, value: value });
                    },
                });
            }), dropdownProps: __assign({ placement: "bottomLeft" }, dropdownSimpleProps === null || dropdownSimpleProps === void 0 ? void 0 : dropdownSimpleProps.dropdownProps) }), (children === null || children === void 0 ? void 0 : children.apply(void 0, innerArgs)) ||
            (defaultToggler && (react_1.default.createElement(DropdownSimple_1.DropdownSimple.DropdownSimpleToggler, __assign({}, defaultToggler.apply(void 0, innerArgs)))))));
    };
};
exports.getDropdownSimpleWithRadioBtns = getDropdownSimpleWithRadioBtns;
var getArrayCell = function (children) {
    if (children === void 0) { children = function (val) { return val; }; }
    return function (cells) {
        var rest2 = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            rest2[_i - 1] = arguments[_i];
        }
        return cells.map(function (c) { return children.apply(void 0, __spreadArray([c], rest2)); });
    };
};
exports.getArrayCell = getArrayCell;
